import moment from 'moment'

class BasePropertiesGenerator {

  /**
   * @param {String} sessionId - id текущей сессии
   * @param {String} user - пользователь текущей сессии
   * @param {String} page - страница в которой было совершено действие
   * @param {String} type - тип действия
   * @returns 
   */
  getBaseProperties(sessionId, user, page, type) {
    const data = {
      type,
      page,
      sessionId,
      time: moment().format(),
      user: user || 'unauthorized'
    }

    return data
  }

  /**
   * The function how check and parse userAgent to get browser name
   * @returns {String} return the name of the user browser
   */
  getBrowserName() {
    const agent = navigator.userAgent.toLowerCase()

    switch (true) {
      case agent.indexOf('edgios') > -1:
      case agent.indexOf('edge') > -1:
        return 'MS Edge'
      case agent.indexOf('edg/') > -1:
        return 'Edge ( chromium based)'
      case agent.indexOf('opr') > -1 && !!window.opr:
        return 'Opera'
      case agent.indexOf('crios') > -1:
      case agent.indexOf('chrome') > -1 && !!window.chrome:
        return 'Chrome'
      case agent.indexOf('trident') > -1:
        return 'MS IE'
      case agent.indexOf('fxios') > -1:
      case agent.indexOf('firefox') > -1:
        return 'Mozilla Firefox'
      case agent.indexOf('safari') > -1:
        return 'Safari'
      default:
        return 'other'
    }
  }

  /**
   * The function how detect the OS name of the user device.
   * navigator.userAgentData (User-Agent Client Hints) is only implemented
   * in Chromium-based browsers, so on WebKit engines (Safari and every
   * browser on iOS, which is required by Apple to use WebKit) it falls
   * back to parsing navigator.userAgent, the same way getBrowserName() does.
   * @returns {String} return the name of the user OS
   */
  getOSName() {
    if (navigator.userAgentData?.platform) {
      return navigator.userAgentData.platform
    }

    const agent = navigator.userAgent.toLowerCase()

    switch (true) {
      case agent.indexOf('iphone') > -1:
      case agent.indexOf('ipad') > -1:
      case agent.indexOf('ipod') > -1:
        return 'iOS'
      case agent.indexOf('android') > -1:
        return 'Android'
      case agent.indexOf('windows') > -1:
        return 'Windows'
      case agent.indexOf('mac os x') > -1:
        // iPadOS 13+ requests the desktop site by default and reports itself as Mac
        return navigator.maxTouchPoints > 1 ? 'iOS' : 'macOS'
      case agent.indexOf('linux') > -1:
        return 'Linux'
      default:
        return 'other'
    }
  }
}

export default new BasePropertiesGenerator()
